import type { LangMap } from "./index";
import { learnIt } from "./learn.it";
import { learnEn } from "./learn.en";
import { learnEs } from "./learn.es";
import { learnFr } from "./learn.fr";
import { learnDe } from "./learn.de";
import { learnPt } from "./learn.pt";

export const learn: LangMap = {
  en: learnEn,
  it: learnIt,
  es: learnEs,
  fr: learnFr,
  de: learnDe,
  pt: learnPt,
};
